module.exports = __webpack_public_path__ + "static/bart-ter-steege-01e5e8cc02315d563fa885c9ba604150.png";